import { Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import type { FC } from "react";
import { useState } from "react";
import AsyncLoadingButton from "../../components/asyncLoadingButton/AsyncLoadingButton";
import CancelButton from "../../components/cancelButton/CancelButton";
import CustomerSelect from "../../components/customerSelect/CustomerSelect";

interface Props {
  readonly draftText: string;
  readonly customerId: string | null;
  readonly onCustomerChange?: (customerId: string | null) => void;
  readonly readOnlyCustomer: boolean;
  readonly onSave: (editedText: string, customerId: string) => Promise<void>;
  readonly onClose: () => void;
}

const CreateCallRecordingNoteDialog: FC<Props> = ({
  draftText,
  customerId,
  onCustomerChange,
  readOnlyCustomer,
  onSave,
  onClose,
}) => {
  const [text, setText] = useState(() => draftText);

  const canSave = text.trim().length > 0 && (readOnlyCustomer || customerId !== null);

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Notatka z nagrania rozmowy</DialogTitle>
      <DialogContent>
        {!readOnlyCustomer && onCustomerChange && (
          <CustomerSelect
            customerId={customerId}
            onChange={(selectedCustomerId) => onCustomerChange(selectedCustomerId)}
          />
        )}
        <TextField
          label="Treść notatki"
          value={text}
          onChange={(e) => setText(e.target.value)}
          multiline
          minRows={4}
          fullWidth
          sx={{ marginTop: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <CancelButton onClick={onClose} />
        <AsyncLoadingButton
          disabled={!canSave}
          onClick={async () => {
            if (customerId === null) {
              return;
            }
            await onSave(text, customerId);
            onClose();
          }}
        >
          Zapisz
        </AsyncLoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default CreateCallRecordingNoteDialog;
